import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X, Download } from "lucide-react";
import { usePwaInstall } from "@/hooks/usePwaInstall";

const DISMISS_KEY = "hmc_install_dismissed";

export const InstallBanner = () => {
  const { canInstall, promptInstall, installed, isIOS } = usePwaInstall();
  const [dismissed, setDismissed] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === "1");
  }, []);

  const hide =
    dismissed ||
    installed ||
    (!canInstall && !isIOS) ||
    location.pathname.startsWith("/admin") ||
    location.pathname === "/get-app";

  if (hide) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  const onAction = async () => {
    if (canInstall) {
      const outcome = await promptInstall();
      if (outcome === "accepted") dismiss();
    } else {
      navigate("/get-app");
    }
  };

  return (
    <div className="lg:hidden fixed inset-x-3 bottom-3 z-[60] animate-fade-in" data-testid="install-banner">
      <div className="flex items-center gap-3 rounded-2xl glass-nav bg-navy-900/95 border border-gold-500/30 shadow-2xl px-4 py-3">
        <img src="/app-icon-192.png" alt="" className="h-10 w-10 rounded-xl ring-1 ring-gold-500/30" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-white leading-tight">Add HMC to your home screen</p>
          <p className="text-xs text-slate-300 truncate">
            {isIOS ? "Tap for Add to Home Screen steps" : "One tap — no app store needed"}
          </p>
        </div>
        <button
          onClick={onAction}
          className="shrink-0 inline-flex items-center gap-1.5 bg-gold-500 hover:bg-gold-400 text-navy-900 text-xs font-semibold px-3.5 py-2 rounded-full transition-colors"
          data-testid="install-banner-action"
        >
          <Download className="h-3.5 w-3.5" /> {canInstall ? "Install" : "How"}
        </button>
        <button
          onClick={dismiss}
          aria-label="Dismiss install banner"
          className="shrink-0 h-8 w-8 inline-flex items-center justify-center text-slate-400 hover:text-white transition-colors"
          data-testid="install-banner-dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallBanner;
